import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authService } from '../../service/domain/_service.config'

export function useLogout() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      await authService.signOut()
    },
    onSuccess: () => {
      queryClient.invalidateQueries()
    },
  })
}
